import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getEvent = () => api.get("/event").then((r) => r.data);
export const getAvailableItems = () => api.get("/items/available").then((r) => r.data);
export const getHeadcount = () => api.get("/headcount").then((r) => r.data);
export const getItems = () => api.get("/items").then((r) => r.data);
export const submitRsvp = (payload) => api.post("/rsvp", payload).then((r) => r.data);

export const getRsvps = () => api.get("/rsvps").then((r) => r.data);
export const deleteRsvp = (id) => api.delete(`/rsvps/${id}`).then((r) => r.data);
export const createItem = (payload) => api.post("/items", payload).then((r) => r.data);
export const updateItem = (id, payload) => api.put(`/items/${id}`, payload).then((r) => r.data);
export const deleteItem = (id) => api.delete(`/items/${id}`).then((r) => r.data);
export const verifyPasscode = (passcode) => api.post("/admin/verify", { passcode }).then((r) => r.data);
export const setStatus = (override) => api.put("/admin/status", { override }).then((r) => r.data);
